import useApi from "../../api/useApi";

const useOutgoingPaymentService = () => {

  const {api} = useApi()

  const userShow = (callbackSuccess, callbackValidationErrors, bookingId = null) => {
    return api(
      'get',
      (bookingId) ? 'user/outgoing-payments/booking/' + bookingId : 'user/outgoing-payments',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useOutgoingPaymentService::userShow: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  return {
    userShow,
  }
}
export default useOutgoingPaymentService
